<!-- overlay div is here to make the click outside on the color picker work.
	It doesn't work if the element behind is gojs canvas -->
<div class="color-picker-backdrop" *ngIf="colorPickerOpened"></div>
<button
  mat-icon-button
  [matTooltip]="'Shadow'"
  [intercomTarget]="'toolbar-context-menu-shadow'"
  (click)="isMenuOpen = !isMenuOpen"
  cdkOverlayOrigin
  #trigger="cdkOverlayOrigin"
>
  <fa-icon [icon]="['far', 'tint']"></fa-icon>
</button>
<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="isMenuOpen"
  [cdkConnectedOverlayHasBackdrop]="true"
  cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
  (backdropClick)="closeOverlay()"
>
  <div class="context-menu-shadow">
    <div class="context-menu-shadow-color">
      <div
        class="color-dot"
        [ngStyle]="{
          'background-color': shadow?.color || '#FFF',
          'border-color': shadow?.color || '#000'
        }"
        [colorPicker]="state.shadowColor"
        [cpPositionRelativeToArrow]="true"
        cpPositionOffset="50%"
        cpOutputFormat="hex"
        cpAlphaChannel="disabled"
        (colorPickerChange)="onColorChange($event)"
        (cpToggleChange)="colorPickerOpened = $event"
      ></div>
      {{ state.shadowColorWithoutHash }}
    </div>
    <div class="context-menu-shadow-label">x</div>
    <mat-slider
      min="0"
      max="30"
      step="1"
      thumbLabel="false"
      [value]="(shadow || _defaultShadow).offset.x"
      (input)="onXOffsetChange($event)"
    ></mat-slider>
    <div>{{ (shadow || _defaultShadow).offset.x }}</div>
    <div class="context-menu-shadow-label">y</div>
    <mat-slider
      min="0"
      max="30"
      step="1"
      thumbLabel="false"
      [value]="(shadow || _defaultShadow).offset.y"
      (input)="onYOffsetChange($event)"
    ></mat-slider>
    <div>{{ (shadow || _defaultShadow).offset.y }}</div>
    <div class="context-menu-shadow-label">
      <fa-icon [icon]="['far', 'tint']"></fa-icon>
    </div>
    <mat-slider
      min="0"
      max="30"
      step="1"
      thumbLabel="false"
      [value]="(shadow || _defaultShadow).blur"
      (input)="onBlurChange($event)"
    ></mat-slider>
    <div>{{ (shadow || _defaultShadow).blur }}%</div>
  </div>
</ng-template>
